<template>
  <div class="prevent">
    <div class="content">
      <p>当前列禁止编辑或新增，，如需进行编辑或新增操作请在AIMS中操作。数据将恢复，谢谢。</p>
    </div>
    <div class="footer">
<!--      <el-button @click="submit()" type="primary" :loading="loading">确定</el-button>-->
    </div>
  </div>
</template>

<script>
export default {
  name: "editor",
  data() {
    return {
      loading: false
    }
  },
  methods: {
    submit() {
      this.loading = true;
      // let messageObject = {};
      // let jsonMessage = JSON.stringify(messageObject);
      Office.context.ui.messageParent('{}');
    }
  }
}
</script>

<style scoped lang="less">
.prevent {
  .content {
    padding: 1rem;
    color: #f9ae3a;
    //border-radius: 10px;
  }

  .footer {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 10px 1rem;
    background: #fff;
    text-align: right;
  }
}
</style>
